import './styles/global.css';
import { Navigate, Route, Routes } from 'react-router-dom';
import HomePage from './pages/HomePage';
import VotePage from './pages/VotePage';
import ModelsPage from './pages/ModelsPage';
import ActressesPage from './pages/ActressesPage';
import DancersPage from './pages/DancersPage';
import { RegisterModalProvider } from './contexts/RegisterModalContext';
import { LanguageProvider } from './contexts/LanguageContext';

export default function App() {
  return (
    <LanguageProvider>
      <RegisterModalProvider>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/models" element={<ModelsPage />} />
          <Route path="/actresses" element={<ActressesPage />} />
          <Route path="/dancers" element={<DancersPage />} />
          <Route path="/:slug/*" element={<VotePage />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </RegisterModalProvider>
    </LanguageProvider>
  );
}
